import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import VueDateFns from 'vue-date-fns'
import locale from 'date-fns/locale/fr'
import Axios from 'axios'
import VueMeta from 'vue-meta'
import workingDays from '@/plugins/workingDays'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

Vue.prototype.$workingDays = workingDays
Vue.prototype.$http = Axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`
}
Vue.config.productionTip = false

Vue.use(VueDateFns, '', { locale })

Vue.use(VueMeta)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
